import { useEffect, useState } from 'react';
import { useMediaQuery } from './useMediaQuery';

export const PAGE_SCROLL_QUERY = '(max-width: 768px)';

export function usePageScroll(): boolean {
  return useMediaQuery(PAGE_SCROLL_QUERY);
}

export function scrollAppToTop(pageScroll: boolean, viewport: Element | null): void {
  if (pageScroll) window.scrollTo({ top: 0 });
  else viewport?.scrollTo({ top: 0 });
}

export function appScrollTop(pageScroll: boolean, viewport: Element | null): number {
  return pageScroll ? window.scrollY : (viewport?.scrollTop ?? 0);
}

export function useDocumentTop(el: HTMLElement | null, enabled: boolean): number {
  const [top, setTop] = useState(0);

  useEffect(() => {
    if (!enabled || !el) return;
    const measure = () => {
      const next = Math.round(el.getBoundingClientRect().top + window.scrollY);
      setTop((prev) => (prev === next ? prev : next));
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(document.documentElement);
    ro.observe(el);
    window.addEventListener('resize', measure);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [el, enabled]);

  return enabled ? top : 0;
}
